// extracted by mini-css-extract-plugin
export default {"root":"ErrorValidation_root__9mT4U","errors":"ErrorValidation_errors__hOrS+"};